module.exports = __webpack_public_path__ + "files/bc3dc365b018373375354b0676071f90.png";